import React, {useState} from 'react'
import Card from 'react-bootstrap/Card'
import UploadFile from '../ui/UploadFile'
import Button from 'react-bootstrap/Button'
import {useUploadInvoiceFileMutation} from '../store/api'
import useHasPermission from '../hooks/useHasPermission'

const UploadFileContainer = () => {
	const hasUploadPermission = useHasPermission('upload-file')
	const [file, setFile] = useState<null|File>(null)
	const [fileName, setFileName] = useState('')

	const [upload, {isLoading}] = useUploadInvoiceFileMutation()

	const handleFileChange: React.ChangeEventHandler<HTMLInputElement> = (event) => {
		const file = event.target.files
		if (file && file[0]) {
			setFileName(file[0].name)
			setFile(file[0])
		}
	}

	const handleSubmit = async () => {
		if(file){
			try {
				await upload({ file }).unwrap()
				setFileName('')
				setFile(null)
			} catch (error) {
				console.log(error)
			}
		}
	}

	if (!hasUploadPermission) {
		return null
	}

	return (
		<Card className='d-flex align-items-center justify-content-center w-100 position-relative'>
			<Card.Body className={`d-flex flex-column align-items-center ${isLoading && 'placeholder-glow'}`}>
				<Card.Title className={`text-center ${isLoading && 'placeholder'}`}>Завантаження заявки</Card.Title>
				<Card.Text className={isLoading ? 'placeholder' : undefined}>
					Завантажте інвойс
				</Card.Text>
				{isLoading ? <div style={{height: 54, width: 334}} className='placeholder col-4'/> : <UploadFile onChange={handleFileChange} fileName={fileName}/>}
				{isLoading ?
					<Button disabled className='mt-2 placeholder col-4'/> :
					<Button
						variant='primary'
						onClick={handleSubmit}
						disabled={!file || isLoading}
						className='mt-2'
					>
                        Завантажити
					</Button>
				}
			</Card.Body>
		</Card>
	)
}

export default UploadFileContainer
